import script from "./PeriodontalPdf.vue?vue&type=script&setup=true&lang=ts"
export * from "./PeriodontalPdf.vue?vue&type=script&setup=true&lang=ts"

import "./PeriodontalPdf.vue?vue&type=style&index=0&id=48c7651a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c7651a"]])

export default __exports__